import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Popover } from "antd";
import moment from "moment";
import RequestMenu from "./requestMenu";
import { changeViewedSurveyAsk, remindSurveyAsk } from "../../../store/actions/ask/surveys";

const RequestRow = (props) => {
  const { request, reminds, setReminds } = props;
  const navigate = useNavigate();
  const company = useSelector((state) => state.company);
  const main = useSelector((state) => state.main);
  const myType = main.myType;
  const dispatch = useDispatch();

  const createdByManager = request.createdByManager;
  const companies = company.companies;
  if (!companies) return undefined;
  const currentCompanyData = companies.find((c) => c.uuid === request.itemId);
  const commercialistiList = currentCompanyData !== undefined ? currentCompanyData.commercialistiList : null;
  let studioRequester;
  let ragioneSociale;
  if (commercialistiList !== null) {
    studioRequester = commercialistiList.find((comm) => comm.uuid === request.managerId);
    ragioneSociale = studioRequester.ragioneSociale;
  }

  return (
    <div
      className={
        myType === "STUDIO"
          ? "askList-panel-reply" + (!request.managerViewedAt && request.createdAt && request.completedAt ? " not-viewed" : "")
          : "askList-panel-reply clientList " + (!request.itemViewedAt && request.createdAt && !request.completedAt ? " not-viewed" : "")
      }
      onClick={() => {
        const routeRedirect = request.itemId ? "/ask-answer/" : "/ask-edit/?draftId=";
        navigate(routeRedirect + (request.answerId ? request.answerId : request.id));
      }}
    >
      <div className="askList-icons" style={{ width: "3%" }}>
        {((myType === "STUDIO" && request.completedAt) || (myType !== "STUDIO" && request.createdAt && request.answerId && !request.completedAt)) && (
          <Tooltip
            color={"rgb(0, 80, 117)"}
            title={
              (myType === "STUDIO" && !request.managerViewedAt && request.completedAt) ||
              (myType !== "STUDIO" && !request.itemViewedAt && request.createdAt) ? (
                  <FormattedMessage id="ask.pages.list.markAsRead" />
                ) : (
                  <FormattedMessage id="ask.pages.list.markAsUnread" />
                )
            }
          >
            <FontAwesomeIcon
              onClick={(e) => {
                e.stopPropagation();
                const viewed =
                  myType === "STUDIO"
                    ? !request.managerViewedAt && request.createdAt && request.completedAt
                      ? true
                      : false
                    : !request.itemViewedAt && request.createdAt;

                dispatch(changeViewedSurveyAsk(request.answerId, viewed));
              }}
              icon={
                myType === "STUDIO"
                  ? [!request.managerViewedAt && request.createdAt && request.completedAt ? "fas" : "far", "circle"]
                  : [!request.itemViewedAt && request.createdAt ? "fas" : "far", "circle"]
              }
              style={{ fontSize: 8 }}
            />
          </Tooltip>
        )}
      </div>
      <div style={{ width: myType === "STUDIO" ? "37%" : "48%", paddingLeft: createdByManager === undefined ? "26px" : 0 }}>
        <div /* className="askList-reply-title" onClick={() => navigate('/ask-answer/' + request.answerId)}*/>
          <>
            {createdByManager !== undefined && (
              <Tooltip
                color={"rgb(0, 80, 117)"}
                title={
                  myType === "STUDIO" ? (
                    createdByManager ? (
                      <FormattedMessage id="ask.pages.list.requestByStudio" />
                    ) : (
                      <FormattedMessage id="ask.pages.list.requestByClient" />
                    )
                  ) : createdByManager ? (
                    `Richiesta di ${ragioneSociale}`
                  ) : (
                    <FormattedMessage id="ask.pages.list.myOwnRequest" />
                  )
                }
              >
                <FontAwesomeIcon
                  icon={["far", createdByManager === true ? "briefcase" : "user"]}
                  style={{ color: "black", fontSize: "16px", marginRight: "10px" }}
                />
              </Tooltip>
            )}
            {request.title}
          </>
        </div>
      </div>
      {myType === "STUDIO" && (
        <div style={{ width: "20%" }}>
          <div className="askList-reply-recipient">{request.itemDescription ? request.itemDescription : ""}</div>
        </div>
      )}
      <div style={{ width: myType === "STUDIO" ? "14%" : "17%" }}>
        {myType === "STUDIO" && !request.itemId ? (
          <span>
            <FontAwesomeIcon icon={["fas", "flag"]} style={{ marginRight: 10, color: "#d82829", fontSize: 16 }} />{" "}
            <FormattedMessage id="ask.pages.list.draft" />
          </span>
        ) : (myType === "STUDIO" && request.createdAt && !request.completedAt) ||
          (myType !== "STUDIO" && request.createdAt && !request.completedAt && !request.remindedAt) ? (
            <span>
              <FontAwesomeIcon icon={["fas", "exclamation-circle"]} style={{ marginRight: 10, color: "#fdb927", fontSize: 16 }} />{" "}
              <FormattedMessage id={myType === "STUDIO" ? "ask.pages.list.notFilled" : "ask.pages.list.toFill"} />{" "}
            </span>
          ) : request.createdAt && request.completedAt ? (
            <span>
              <FontAwesomeIcon icon={["fas", "check-circle"]} style={{ marginRight: 10, color: "#09822a", fontSize: 16 }} />{" "}
              <FormattedMessage id="ask.pages.list.filled" />{" "}
            </span>
          ) : myType !== "STUDIO" && request.remindedAt ? (
            <span>
              <FontAwesomeIcon icon={["fas", "bells"]} style={{ marginRight: 10, color: "#d82829" }} />
              <FormattedMessage id="ask.pages.list.solicited" />
            </span>
          ) : null}
      </div>
      {myType !== "STUDIO" && (
        <div style={{ width: "12%" }}>
          {request.createdAt ? <div className="askList-reply-createdAt">{moment(request.createdAt).format("DD MMM YYYY")}</div> : "-"}
        </div>
      )}
      {myType === "STUDIO" && (
        <div style={{ width: "10%" }}>
          {request.createdAt && request.answerId && request.itemId ? (
            <div className="askList-reply-createdAt">{moment(request.createdAt).format("DD MMM YYYY")}</div>
          ) : (
            "-"
          )}
        </div>
      )}
      <div style={{ width: myType === "STUDIO" ? "10%" : "14%" }}>
        {request.completedAt ? <div className="askList-reply-completedAt">{moment(request.completedAt).format("DD MMM YYYY")}</div> : "-"}
      </div>
      <div
        className="askList-icons"
        style={{
          width: "6%",
          display: "flex",
          justifyContent: "flex-end"
        }}
      >
        {myType === "STUDIO" && !request.completedAt ? (
          <Tooltip
            color={"rgb(0, 80, 117)"}
            title={
              !request.completedAt && request.createdAt ? (
                request.remindedAt || reminds.indexOf(request.answerId) > -1 ? (
                  <FormattedMessage id="ask.pages.list.solicitAgain" />
                ) : (
                  <FormattedMessage id="ask.pages.list.solicit" />
                )
              ) : (
                ""
              )
            }
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                if (!request.completedAt || request.itemId) {
                  dispatch(remindSurveyAsk(request.answerId)).then(() => {
                    if (window.aptrinsic) {
                      window.aptrinsic("track", "digital-box:ASK-SOLICIT");
                    }
                    setReminds([...reminds, request.answerId]);
                  });
                }
              }}
              className={
                "iconBells" +
                (request.completedAt || !request.itemId ? " disabled" : "") +
                (!request.completedAt && (request.remindedAt || reminds.indexOf(request.answerId) > -1) ? " already" : "")
              }
              style={{
                width: 40,
                cursor: request.createdAt && !request.completedAt ? "pointer" : "default"
              }}
            >
              {!request.completedAt && request.createdAt && <FontAwesomeIcon icon={["far", "bells"]} />}
            </div>
          </Tooltip>
        ) : null}

        {myType === "STUDIO" && (
          <Popover
            overlayClassName="askList-actions-popover"
            placement="top"
            content={
              <div>
                <RequestMenu
                  sent={request.itemId ? request.createdAt : ""}
                  answerId={request.answerId ? request.answerId : request.id}
                  /* templateId={request.templateId}*/
                  completed={request.completedAt}                  
                />
              </div>
            }
            onClick={(e) => {
              e.stopPropagation();
            }}
            trigger="click"
          >
            <div id={"askList-actions-icon-container_" + request.id} style={{ width: 40 }}>
              <span id={"askList-actions-icon-span_" + request.id}>
                <FontAwesomeIcon id={"askList-actions-icon_" + request.id} icon={["far", "ellipsis-v"]} style={{ marginLeft: 5, marginRight: 5 }} />
              </span>
            </div>
          </Popover>
        )}
      </div>
    </div>
  );
};

export default RequestRow;
